import { fetcher, queryString, useRecoilQuery } from '@shared/hooks/recoil-query';
import { LowerRole } from '@shared/types';

import {
  giftItemBrandDataAtomFamily,
  giftItemBrandListDataAtom,
  giftItemBrandListStatusAtom,
  giftItemBrandStatusAtomFamily,
} from './giftItemBrand.atom';

// GiftItemBrand 목록 조회
export const giftItemBrandListUrl = (role: LowerRole) => {
  return `/${role}/gift-item-brand?${queryString({
    populate: { path: 'thanksPrint.templates.templateImage' },
    // 표시 순서 우선 — 순서 미설정(저장 전)이면 이름순과 같다
    options: { sort: { order: 1, name: 1 } },
  })}`;
};

export const useGiftItemBrandListHook = (role: LowerRole, skip = false) => {
  useRecoilQuery(
    giftItemBrandListStatusAtom,
    giftItemBrandListDataAtom,
    giftItemBrandListUrl(role),
    fetcher,
    skip,
  );
};

// GiftItemBrand 단건 조회 (감사인쇄 템플릿 이미지 populate)
export const giftItemBrandUrl = (id: string, role: LowerRole) => {
  return `/${role}/gift-item-brand/${id}?${queryString({
    populate: { path: 'thanksPrint.templates.templateImage' },
  })}`;
};

export const useGiftItemBrandHook = (id: string, role: LowerRole, skip = false) => {
  useRecoilQuery(
    giftItemBrandStatusAtomFamily(id),
    giftItemBrandDataAtomFamily(id),
    giftItemBrandUrl(id, role),
    fetcher,
    skip || !id,
  );
};
